import { CheckboxInput, FormItem } from '@framework/form';
import { yup } from '@framework/validation';
import React from 'react';
import { ReferenceSchema } from '../../../../expressions/validation/ReferenceSchema';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../../inputs/common/CommonInputConfigComponent';
import {
  IRepeatControllerWidget,
  RepeatControllerComponentType,
} from './IRepeatControllerWidget';
import { RepeatableListSelectInput } from './components/RepeatableListSelectInput';

export const RepeatControllerConfigSchema: yup.ObjectSchema<IRepeatControllerWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.RepeatController).required(),
    kind: yup
      .string()
      .oneOfEnum(RepeatControllerComponentType)
      .required()
      .default(RepeatControllerComponentType.Input)
      .label('Tipo di input'),
    listReference: ReferenceSchema.required().label('Riferimento lista'),
    confirmReduce: yup.boolean().default(true).label('Conferma eliminazione'),
  });

export interface IRepeatControllerWidgetConfigComponentProps
  extends IWidgetComponentProps<IRepeatControllerWidget> {}

export function RepeatControllerWidgetConfigComponent(
  props: IRepeatControllerWidgetConfigComponentProps,
) {
  return (
    <>
      <RepeatableListSelectInput />
      <CommonConfigComponent {...props} noConfirmation={true} />
      <FormItem
        name="confirmReduce"
        label="Conferma eliminazione"
        help="Richiedi all'utente conferma prima di ridurre il numero di elementi della lista."
      >
        <CheckboxInput name="confirmReduce" defaultChecked={true}>
          Richiedi la conferma
        </CheckboxInput>
      </FormItem>
    </>
  );
}
